import { Typography, LazyImage, Tooltip } from '@frontend/design_system'
import styles from './styles.module.scss'
import { PercentBadge } from 'ui/atoms/PercentBadge'
import { WidgetItemProps } from './types'
import { DASHBOARD_WIDGET } from 'texts/dashboard'
import infoIcon from 'assets/icons/grey400/grey400_infoIcon_16x16.webp'

export const WidgetItem = ({
  counter,
  percent,
  counterLabel,
  dataTestId,
}: WidgetItemProps) => (
  <div className={styles.item} data-testid={dataTestId}>
    <div className={styles['counter-wrapper']}>
      <Typography
        className={styles.counter}
        name="h5WMedium"
        html={counter}
        markName="subtitleWMedium"
        dataTestId={`${dataTestId}-counter`}
      />
      {counterLabel && (
        <Typography
          name="body1WRegular"
          color="grey500"
          dataTestId={`${dataTestId}-counter-label`}
        >
          {counterLabel}
        </Typography>
      )}
    </div>
    <Typography
      Tag="div"
      name="caption1WRegular"
      color="grey500"
      className={styles['percent-wrapper']}
    >
      <PercentBadge percent={percent} />
      {DASHBOARD_WIDGET.PREVIOUS_PERIOD}
      <Tooltip
        size="primary"
        popupContent={
          typeof percent === 'number'
            ? DASHBOARD_WIDGET.TOOLTIP_WITH_VALUE
            : DASHBOARD_WIDGET.TOOLTIP_WITHOUT_VALUE
        }
        placement="bottom"
      >
        <LazyImage src={infoIcon} width={16} height={16} />
      </Tooltip>
    </Typography>
  </div>
)
